import { AnchorBoxStoryblok } from "@/types/component-types"
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from "@storyblok/react/rsc"

import { BlokProps } from "@helpers/StoryblokHelpers"

export const AnchorBox = ({ blok }: BlokProps<AnchorBoxStoryblok>) => (
  <div id={blok.box_id} style={{ display: "contents" }} {...storyblokEditable(blok as SbBlokData)}>
    <StoryblokServerComponent blok={blok.item[0]} />
  </div>
)

export default AnchorBox
